<app-text [alias]="'faculty_category_component'"></app-text>
<app-button-list>
    <app-button (clickedEvent)="show()">Add Faculty Category Code </app-button>
</app-button-list>
<mat-card>
    <mat-card-content>
        <app-table-filter [compactButtons]="true" [filterItems]="filters" [tableName]="tableName"></app-table-filter>
    </mat-card-content>
</mat-card>
<app-table [tableName]="tableName" [baseUrl]="baseUrl" [columns]="columns"></app-table>